import type ApplicationInstance from "@ember/application/instance";
import ControlTower from "wise-control-tower";

export function initialize(appInstance: ApplicationInstance) {
  ControlTower.instrumentPerformance(appInstance);
}

export default {
  initialize
};
